import GlideCarousel from '@/js/glide-carousel';

class TestimonialsCarousel extends GlideCarousel {
  connectedCallback() {
    this.carouselElements = this.querySelectorAll('[data-glide]');
    this.options = {
      autoplay: 5000,
      type: 'carousel',
      gap: 112,
      perView: 1,
      peek: {
        before: 0,
        after: 0
      }
    };

    super.connectedCallback();
  }
}

customElements.get('testimonials-carousel') ||
  customElements.define('testimonials-carousel', TestimonialsCarousel);
